import React from 'react';
import { Box, Grid, Typography } from '@mui/material';

type Props = {
  isMobilePreview?: boolean;
  num: number,
  title: string,
  description: string,
  buttonTextColor: string,
}

const StepCard:React.FC<Props> = ({
  isMobilePreview, num, title, description, buttonTextColor,
}) => (
  <Box>
    <Grid
      gap={2}
      direction={{
        xs: 'row',
        sm: isMobilePreview ? 'row' : 'column',
      }}
      alignItems="center"
      flexWrap="nowrap"
      container
    >
      <Grid
        alignSelf={{
          xs: 'start',
          sm: 'center',
        }}
      >
        <Box sx={{
          height: '4.8rem',
          width: '4.8rem',
          borderRadius: '50%',
          backgroundColor: 'primary.main',
          border: '1px solid ',
          borderColor: 'primary.main',
          textAlign: 'center',
          verticalAlign: 'middle',
          lineHeight: '4.8rem',
          color: buttonTextColor,
          fontSize: '2.1rem',
          fontWeight: 'bolder',
          '@media (max-width:600px)': {
            height: '4rem',
            width: '4rem',
            lineHeight: '4rem',
            fontSize: '1.6rem',
          },
        }}
        >
          {num}
        </Box>
      </Grid>

      <Grid
        alignSelf="center"
      >
        <Typography
          component="h2"
          variant="caption"
          gutterBottom
          sx={{
            textAlign: {
              xs: 'left',
              sm: isMobilePreview ? 'left' : 'center',
            },
            textTransform: 'capitalize',
          }}
        >
          {title}

        </Typography>
        <Typography
          variant="body2"
          fontSize={{
            xs: '1.4rem',
            sm: '1.6rem',
          }}
          sx={{
            textAlign: {
              xs: 'left',
              sm: isMobilePreview ? 'left' : 'center',
            },
          }}
        >
          {description}
        </Typography>
      </Grid>
    </Grid>
  </Box>
);

export default StepCard;
